import { useTheme } from '@mui/material';
import { Box } from '@mui/system';

import VectorImage, { type VectorImageName } from '~components/media/vectorImage';
import { StatusVariant } from '~enums';
import { getStatusBackgroundColor, getStatusIconColor } from '~enums/statusVariant';
import { Dimens } from '~themes';

interface FramedIconProps {
	size?: 'small' | 'standard';
	variant?: StatusVariant;
	name: VectorImageName;
}

const FramedIcon = ({
	name,
	variant = StatusVariant.Neutral,
	size = 'standard',
}: FramedIconProps) => {
	const { palette } = useTheme();
	const backgroundColor = getStatusBackgroundColor(variant, palette);
	const iconColor = getStatusIconColor(variant, palette);
	const frameSize = size == 'small' ? '36px' : '48px';
	const iconSize = Dimens.spacing3xl;

	return (
		<Box
			sx={{
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				borderRadius: Dimens.radiusMd,
				height: frameSize,
				width: frameSize,
				minWidth: frameSize,
				minHeight: frameSize,
				background: backgroundColor,
			}}
		>
			<VectorImage name={name} height={iconSize} width={iconSize} color={iconColor} />
		</Box>
	);
};

export default FramedIcon;
